module.exports = __webpack_public_path__ + "img/Path 16 Copy 2@3x.e138d31a.png";